<div [attr.id]="titleId" class='hvac-index-list' >
    <h2 class='hvac-index-card-title' *ngIf="title" [innerHtml]="title | richText"></h2>
    <div class='hvac-index-card-list'>
        <hvac-content-card *ngFor="let item of contentList" [cardContent]="item"></hvac-content-card>
    </div>
</div>
